import React from 'react';

import InternalBanner from './InternalBanner';


export default function Contact() {
    return (
        <>

            <InternalBanner title="Contact Us" />
            <section id="nutrition" className="contact-part">
                <div className="container contact-box">
                    <div className="row">
                        <div className="col-md-6 col-lg-4">
                            <div className="contact-card h-100">
                                <div className='ic-text'>
                                    <i className="icofont-location-pin"></i>
                                    <h4>head office</h4>
                                </div>
                                <h6></h6>
                                <p>
                                <strong>Rashtriya e-Pustakalaya Secretariat</strong><br></br>
                                    National Book Trust, India<br></br>
                                    3rd Floor, 5 Institutional Area,
                                    Phase-II,<br></br> Vasant Kunj, New Delhi – 110070
                                </p>
                              {/*   <p>NATIONAL BOOK TRUST, INDIA<br></br>
                                    Nehru Bhawan, 5 Institutional Area,
                                    <br></br>Phase-II Vasant Kunj,<br></br> New Delhi -110070</p> */}
                                {/*  <p>NATIONAL BOOK TRUST, INDIA Nehru Bhawan, 5 Institutional Area, Phase-II Vasant Kunj, New Delhi -110070</p> */}
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="contact-card h-100">
                                <div className='ic-text'>
                                    <i className="icofont-phone"></i>
                                    <h4>phone number</h4>
                                </div>
                                <p>
                                    <span>+91-9319703004</span>

                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="contact-card h-100">
                                <div className='ic-text'>
                                    <i className="icofont-email"></i>
                                    <h4>Support mail</h4>
                                </div>
                                <p>
                                    <span>rashtriyaepustakalaya@gmail.com</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row d-none">

                        <div className="col-lg-6 col-md-6">
                            <form className="contact-form">
                                <h4 className="mb-3 contact-title">Get in touch</h4>
                                <div className="form-group mb-0">
                                    <div className="did-floating-label-content form-input-group">
                                        <input className="did-floating-input form-control" type="text" placeholder=" " />
                                        <label className="did-floating-label">Your Name *</label>
                                        <i className="fas fa-user"></i>
                                    </div>
                                </div>
                                <div className="form-group mb-0">
                                    <div className="did-floating-label-content form-input-group">
                                        <input className="did-floating-input form-control" type="text" placeholder=" " />
                                        <label className="did-floating-label">Your Email *</label>
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                </div>
                                <div className="form-group mb-0">
                                    <div className="did-floating-label-content form-input-group">
                                        <input className="did-floating-input form-control" type="text" placeholder=" " />
                                        <label className="did-floating-label">Your Subject *</label>
                                        <i className="fas fa-file-alt"></i>
                                    </div>
                                </div>

                                <div className="form-group mb-0">
                                    <div className="did-floating-label-content form-input-group">
                                        <textarea className="did-floating-input form-control" placeholder="" required ></textarea>
                                        <label className="did-floating-label">Message *</label>
                                        <i className="fas fa-comment"></i>
                                    </div>
                                </div>
                                <div className="section-btn-25 mt-0">
                                    <a href="/contact" className="btn btn_orange">
                                        Send
                                    </a>
                                </div>
                            </form>
                        </div>

                    </div>

                </div>
            </section>



        </>
    )
}
